import { type AmountType } from '@alfa-bank/newclick-types';
import { atom } from 'jotai';

import { defaultAmount } from '../../constants';

export const transferAmountAtom = atom<AmountType>(defaultAmount);

export const transferErrorAtom = atom<string | null>(null);
